import axios from 'axios'
import router from '@/router'
import { clearAuth, getAccessToken } from '@/auth'

const API_BASE = process.env.VUE_APP_API_BASE || (process.env.NODE_ENV === 'development' ? '/api' : '')

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000
})

api.interceptors.request.use((config) => {
  const token = getAccessToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => {
    if (response?.data?.message === 'unauthorized') {
      clearAuth()
      if (router.currentRoute.path !== '/login') {
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      }
    }
    return response
  },
  (error) => {
    const status = error?.response?.status
    if (status === 401 || status === 403) {
      clearAuth()
      if (router.currentRoute.path !== '/login') {
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      }
    }
    return Promise.reject(error)
  }
)

export default api
export { API_BASE }
